import { debug } from '../logger';
import { AliOSSUploader } from '../net/uploader/alioss';
import type { UploadOSSConfig } from 'zf-infra';
import type { CompressParams } from './types';

class Media {

  /**
   * 获取图片的宽高
   * @param src
   * @returns
   */
  async getImageSize(src: string): Promise<{ width: number; height: number }> {
    const img = new Image();
    return await new Promise(resolve => {
      img.src = src;
      img.onload = (): void => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = (): void => {
        console.error('image loading failed:', src);
      };
    });
  }

  getOssURL(src: string, baseName?: string, internal?: boolean): string {
    if (src.startsWith('blob:')) {
      return src;
    }
    if (src.startsWith('http://') || src.startsWith('https://')) {
      return src;
    }

    const internalParams = internal === true ? '&internal=1' : '';

    if (baseName != null) {
      return `${baseName}/api/oss/redirect?name=${src}${internalParams}`;
    }

    return `/api/oss/redirect?name=${src}${internalParams}`;
  }

  getFileType(blob: Blob): 'image' | 'video' | 'file' {
    const { type } = blob;

    if (type.startsWith('image/')) {
      return 'image';
    }

    if (type.startsWith('video/')) {
      return 'video';
    }

    return 'file';
  }


  toImage(blob: Blob): string {
    return URL.createObjectURL(blob);
  }

  /**
   * 处理图片，并覆盖原图（仅限OSS使用）
   * https://help.aliyun.com/document_detail/144582.htm
   * @param id
   * @param params
   */
  async compress(id: string, params: CompressParams, ossConfig?: UploadOSSConfig): Promise<void> {
    debug.infra('compress', id, params);

    const client = await new AliOSSUploader().getClient(ossConfig);
    const option = this.formatCompressParams(params);
    debug.infra('compress option', option);

    // TODO: 补充不足的ts类型
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    await client.processObjectSave(id, id, option);
  }

  /**
   * 转换为处理图片的参数，如 'image/resize,l_100/quality,Q_80'
   * @param params
   * @returns
   */
  private formatCompressParams(params: CompressParams): string {
    let result = 'image/format,jpg/';

    if (params.resize != null) {
      result = `${result}/resize,l_${params.resize}`;
    }

    if (params.quality != null && params.quality < 100) {
      result = `${result}/quality,Q_${params.quality.toFixed()}`;
    }

    return result;
  }

}

export const media = new Media();
